/**
 * Email lead ingest connection schemas.
 *
 * One connection per tenant — tenant picks provider (gmail | m365) and
 * configures which header field + value to match when filtering inbound
 * emails into leads.
 */
import { z } from "zod";
export const EMAIL_PROVIDERS = ["gmail", "m365"];
export const EMAIL_MATCH_FIELDS = ["subject", "to"];
/** GET /settings/email-connection */
export const EmailConnectionResponseSchema = z.object({
    id: z.string().uuid(),
    provider: z.enum(EMAIL_PROVIDERS),
    email_address: z.string(),
    match_field: z.enum(EMAIL_MATCH_FIELDS),
    match_value: z.string(),
    last_polled_at: z.string().datetime().nullable(),
    status: z.enum(["connected", "paused", "error"]),
    /** When true, outbound lead emails route through this Gmail account. */
    send_outbound: z.boolean(),
    created_at: z.string().datetime(),
});
/** POST /settings/email-connection/connect */
export const EmailConnectionConnectResponseSchema = z.object({
    auth_url: z.string().url(),
});
/** PATCH /settings/email-connection */
export const UpdateEmailConnectionRequestSchema = z.object({
    match_field: z.enum(EMAIL_MATCH_FIELDS).optional(),
    match_value: z.string().min(1).max(200).optional(),
    status: z.enum(["connected", "paused"]).optional(),
    send_outbound: z.boolean().optional(),
});
//# sourceMappingURL=email-connection.js.map